export const DealContractForms = [
  { text: 'ПДКП', value: 'pdkp' },
  { text: 'Цессия', value: 'cessia' },
  { text: 'ДДУ', value: 'ddu' },
  { text: 'ДКП', value: 'dkp' },
];
